import { Component, EventEmitter, OnInit, AfterViewChecked, Output } from '@angular/core';
import { EventService } from "../../core/services/event.service";
import { UiStateService } from "../../core/services/ui-state.service";
import { EditGoalDialogComponent } from "../../core/components/edit-goal-dialog/edit-goal-dialog.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PageService } from "../../core/services/page.service";
import { HttpClient } from "@angular/common/http";
import { ToastrService } from "ngx-toastr";
import { DonationService } from '../../core/services/donation.service';
import { PostService } from '../../core/services/post.service';
import { Angulartics2 } from 'angulartics2';
import {PermissionService} from "../../core/services/permission.service";
import {SplashScreen} from '@capacitor/splash-screen';
import {HybridToolsService} from "../../core/services/hybrid-tools.service";

declare var moment: any;

@Component({
    selector: 'cat-page',
    templateUrl: './home.page.html',
    styleUrls: ['./home.component.scss']
})

export class HomePage implements OnInit, AfterViewChecked {
    donationData = null;
    activity = [];
    activityCounter = 0;
    postTitle = '';
    isTextAreaFocused = false;
    isInputFocused = false;
    textValue = '';
    userPage: any = {};
    showTeamGoal: boolean;
    public pageId: number;

    splashDisplayed = true;

    @Output() onEditSave: EventEmitter<any> = new EventEmitter();

    constructor(public uiStateService: UiStateService,
                public eventService: EventService,
                public permissionService: PermissionService,
                private modalService: NgbModal,
                private activatedRoute: ActivatedRoute,
                private pageService: PageService,
                private http: HttpClient,
                private ToastrService: ToastrService,
                public donationService: DonationService,
                private postService: PostService,
                private angulartics2: Angulartics2,
                private router: Router,
                public hybridToolsService: HybridToolsService) {
        this.eventService.onEventChange.subscribe(event => {
            this.activity = [];
            this.activityCounter = 0;
            this.loadDonations();
            this.checkShowTeamGoal();
            this.pageService.getUserPage(this.eventService.selectedEvent.participantId, true)
                .subscribe(page => {
                    this.userPage = page;
                });
        });
    }

    ngAfterViewChecked() {
        //needed when using 'remember me' on iOS
        this.hideSplashScreen();
    }

    hideSplashScreen() {
        if (this.splashDisplayed && this.hybridToolsService.isMobileApp()) {
            this.splashDisplayed = false;
            SplashScreen.hide();
        }
    }

    openChangeGoalModal() {
        const editGoalModal = this.modalService.open(EditGoalDialogComponent);
    }

    onTextareFocus() {
        this.isTextAreaFocused = true;
    }

    onTextareaBlur() {
        this.isTextAreaFocused = false;
    }

    onInputFocus() {
        this.isInputFocused = true;
    }

    onInputBlur() {
        this.isInputFocused = false;
    }

    isPostContentShown() {
        return this.isInputFocused || this.postTitle.length > 0;
    }

    isPostButtonShown() {
        return this.textValue.replace(/\s/g, '').length > 0;
    }

    loadDonations() {
        this.eventService.selectedEvent.donations.donationList.sort(function (a, b) {
            return moment.utc(b.donationDate).diff(moment.utc(a.donationDate));
        });

        for (let i = this.activityCounter; i < this.eventService.selectedEvent.donations.donationList.length; i++) {
            const donation = this.eventService.selectedEvent.donations.donationList[i];
            this.activity.push({
                type: 'donation',
                obj: donation
            });
            if ((i + 1) % 3 == 0) {
                break;
            }
        }
        this.activityCounter += 3;
        try {

        } catch (err) {

        }
    }

    loadMoreDonations() {
        this.loadDonations();
        this.angulartics2.eventTrack.next({
            action: 'Load more',
            properties: {category: 'Home Page'}
        });
    }

    ngOnInit() {
        if (sessionStorage.getItem('impersonationTargetUser')) {
            this.router.navigate(['/impersonation']);
        }
        this.loadDonations();

        this.pageService.getUserPage(this.eventService.selectedEvent.participantId, false)
            .subscribe(page => {
                this.userPage = page;
            });
        this.checkShowTeamGoal();
    }

    checkShowTeamGoal() {
        const role = this.eventService.selectedEvent.gql.Participant[0].teamRoleType;
        if(this.eventService.selectedEvent.gql.Participant[0].team && (this.eventService.selectedEvent.cssClass === 'program-soy' || this.eventService.selectedEvent.cssClass === 'program-svoy') && role.name === 'CAMPAIGN_TEAM_CAPTAIN') {
            this.showTeamGoal = true;
        } else if (this.eventService.selectedEvent.gql.Participant[0].team &&
            this.eventService.selectedEvent.programGroupName === 'MWOY' &&
            (role.name !== 'CANDIDATE' && role.name !== 'HONORED_CANDIDATE_F' && role.name !== 'MWOY_ALL_STAR')) {
            this.showTeamGoal = false;
        } else {
            this.showTeamGoal = this.eventService.selectedEvent.gql.Participant[0].team;
        }
    }

    post() {
        var payload = {
            title: this.postTitle,
            htmlContent: this.textValue,
            urlKey: this.postService
                .generatePostUrlKey(this.postTitle, this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraiserPosts),
            published: true
        };
        this.http.post('/api/v1/pages/' + this.userPage.pageID + '/posts', payload).subscribe(() => {
            this.onEditSave.emit();
            this.ToastrService.success("Post created.");
            this.postTitle = '';
            this.textValue = '';
            this.postService.reloadPosts();
        }, err => {
            this.ToastrService.error("There was problem saving your post.");
        });
    }
}

